"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const rpdf_renderer_1 = require("@surge-global-engineering/rpdf-renderer");
const utils_1 = require("../../utils");
const IS_DEBUG = false;
function ImageCore(_a) {
    var { caption, captionAlignment = 'left', width, link, captionTextStyles, imageContainerStyle, disableURLAppends = false } = _a, rPDFImageProps = tslib_1.__rest(_a, ["caption", "captionAlignment", "width", "link", "captionTextStyles", "imageContainerStyle", "disableURLAppends"]);
    const styles = rpdf_renderer_1.StyleSheet.create({
        image: {
            width: '100%',
        },
        container: {
            width: `${width || 100}%`,
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            textAlign: captionAlignment,
        },
        caption: {
            width: '100%',
            fontStyle: 'italic',
            textDecoration: 'none',
            color: '#000000',
        },
        linkStyle: {
            textDecoration: 'none',
        },
    });
    const imageSrc = rPDFImageProps.src && !disableURLAppends
        ? utils_1.appendUrl(rPDFImageProps.src.toString(), {
            renderer: 'pdf',
        })
        : rPDFImageProps.src;
    return (jsx_runtime_1.jsx(rpdf_renderer_1.View, Object.assign({ style: [styles.container, imageContainerStyle || {}], debug: IS_DEBUG }, { children: jsx_runtime_1.jsxs(rpdf_renderer_1.Link, Object.assign({ src: link || '', style: styles.linkStyle }, { children: [jsx_runtime_1.jsx(rpdf_renderer_1.Image, Object.assign({ debug: IS_DEBUG, style: [styles.image] }, rPDFImageProps, { src: imageSrc }), void 0), caption && (jsx_runtime_1.jsx(rpdf_renderer_1.Text, Object.assign({ debug: IS_DEBUG, style: [styles.caption, captionTextStyles || {}] }, { children: caption }), void 0))] }), void 0) }), void 0));
}
const alignmentToCSSMap = {
    left: 'flex-start',
    center: 'center',
    right: 'flex-end',
};
const Image = (_a) => {
    var { alignment = 'left', wrap = false } = _a, coreImageProps = tslib_1.__rest(_a, ["alignment", "wrap"]);
    return wrap ? (jsx_runtime_1.jsx(rpdf_renderer_1.View, { children: jsx_runtime_1.jsx(ImageCore, Object.assign({ captionAlignment: alignment }, coreImageProps), void 0) }, void 0)) : (jsx_runtime_1.jsx(rpdf_renderer_1.View, Object.assign({ wrap: false, debug: IS_DEBUG, style: {
            width: '100%',
            alignItems: alignmentToCSSMap[alignment],
        } }, { children: jsx_runtime_1.jsx(ImageCore, Object.assign({ captionAlignment: alignment }, coreImageProps), void 0) }), void 0));
};
exports.Image = Image;
exports.default = exports.Image;
//# sourceMappingURL=image.js.map